import React from "react";
import './styles.css';
import setaCimaIcon from '../../assets/images/chevron-solid.svg';
import setaBaixoIcon from '../../assets/images/chevron-solid-bottom.svg';

export class SanfonaModulos extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>
                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>
                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export class SanfonaModulos4 extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>
                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>
                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                            <li>{this.props.moduloResposta2}</li>
                            <li>{this.props.moduloResposta3}</li>
                            <li>{this.props.moduloResposta4}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export class SanfonaModulos6 extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>
                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>
                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                            <li>{this.props.moduloResposta2}</li>
                            <li>{this.props.moduloResposta3}</li>
                            <li>{this.props.moduloResposta4}</li>
                            <li>{this.props.moduloResposta5}</li>
                            <li>{this.props.moduloResposta6}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export class SanfonaModulos8 extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>
                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>
                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                            <li>{this.props.moduloResposta2}</li>
                            <li>{this.props.moduloResposta3}</li>
                            <li>{this.props.moduloResposta4}</li>
                            <li>{this.props.moduloResposta5}</li>
                            <li>{this.props.moduloResposta6}</li>
                            <li>{this.props.moduloResposta7}</li>
                            <li>{this.props.moduloResposta8}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export class SanfonaModulos11 extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>

                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>

                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                            <li>{this.props.moduloResposta2}</li>
                            <li>{this.props.moduloResposta3}</li>
                            <li>{this.props.moduloResposta4}</li>
                            <li>{this.props.moduloResposta6}</li>
                            <li>{this.props.moduloResposta7}</li>
                            <li>{this.props.moduloResposta8}</li>
                            <li>{this.props.moduloResposta9}</li>
                            <li>{this.props.moduloResposta10}</li>
                            <li>{this.props.moduloResposta11}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export class SanfonaModulos14 extends React.Component {

    constructor() {
        super();
        this.state = {
            active: false
        };
    };

    togleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {

        const { active } = this.state;

        return (
            <>
                <div onClick={this.togleClass} className={active ? 'modulo_sanfona-content active' : 'modulo_sanfona-content'}>

                    <div className="modulo_sanfona">
                        <div className="modulo_sanfona-titulo">
                            <img className="seta-icon" src={active ? setaCimaIcon : setaBaixoIcon} alt="" />
                            <h3>{this.props.tituloSanfona}</h3>
                        </div>
                    </div>

                    <div className="container-conteudo">
                        <ul className={active ? 'conteudo active' : 'conteudo'}>
                            <li>{this.props.moduloResposta1}</li>
                            <li>{this.props.moduloResposta2}</li>
                            <li>{this.props.moduloResposta3}</li>
                            <li>{this.props.moduloResposta4}</li>
                            <li>{this.props.moduloResposta6}</li>
                            <li>{this.props.moduloResposta7}</li>
                            <li>{this.props.moduloResposta8}</li>
                            <li>{this.props.moduloResposta9}</li>
                            <li>{this.props.moduloResposta10}</li>
                            <li>{this.props.moduloResposta11}</li>
                            <li>{this.props.moduloResposta12}</li>
                            <li>{this.props.moduloResposta13}</li>
                            <li>{this.props.moduloResposta14}</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}